<main id="main" class="main">
  <div class="mainScreen">
    <div class="row">
      <!-- <h6 class="admintitle" style="height:25px;">{{lang.Tax_Table}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6>
    </div> -->
    <div class="form-group col-12 col-md-12 d-flex justify-content-between"
    style="background: #5d7c9b!important; font-size:14px">
    <h6 class="admintitle">
      {{lang.Tax_Table}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
    </h6>
    <button (click)="openModelAddMumber()" class="addgroupadmininfoemp">+&nbsp;{{lang.Add_New}}</button>
  </div>
    </div>   

<!-- Provinces/States dropdown for selected country (Canada) -->
      <div class="test">
      <div class="column">
        <p style="font-size: 14px;font-family: sans-serif;margin-right:28px;">Select Country</p>

        <!-- Display the list based on selected region -->
       
          <div class="form-group col-12 col-md-3">
            <div class="custom-dropdown-width" style="margin-top: -5px;">
            <div class style="margin-top: -5px">
               <ng-multiselect-dropdown class="ftsize" formControlName="multiSelectProviance"
                placeholder="Canada" [settings]="dropdownSettings" [data]="configprovincereslist1"
                (onSelect)="multiSelectProvianceItemSelect($event)"
                (onSelectAll)="multiSelectProvianceSelectAll($event)"
                (onDeSelect)="multiSelectProvianceItemDeSelect($event)" (onDeSelectAll)="
                  multiSelectProvianceItemDeSelectAll($event)
                " style="background-color: rgb(232, 234, 240);">
              </ng-multiselect-dropdown> 
            </div>
            </div>
            
          </div>
    

        <div>
          <div class="form-group col-12 col-md-3">
            <div class="custom-dropdown-width" style="margin-top: -5px;">
            <div class style="margin-top: -5px">
               <ng-multiselect-dropdown class="ftsize" formControlName="multiSelectProviance1"
                placeholder="USA" [settings]="dropdownSettings" [data]="configprovincereslist2"
                (onSelect)="multiSelectProvianceItemSelect1($event)"
                (onSelectAll)="multiSelectProvianceSelectAll1($event)" 
                (onDeSelect)="multiSelectProvianceItemDeSelect1($event)" (onDeSelectAll)="
                  multiSelectProvianceItemDeSelectAll1($event)
                " style="background-color: rgb(232, 234, 240);">
              </ng-multiselect-dropdown> 
            </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="column2">
        <p style="font-size: 14px;font-family: sans-serif;margin-left:-10px;">Tax Table </p>

        <div class="row">
          <table class="table">
            <thead>
              <tr>
                <th style="font-size: 12px;font-family: sans-serif">Version</th>
                <th style="font-size: 12px;font-family: sans-serif">Start Date</th>
                <th style="font-size: 12px;font-family: sans-serif">End Date</th>
                <!-- <th>V44(A)</th> -->
                <th>Notes <select id="ppcars"></select></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of tableData; let i = index">
                <td style="font-size: 12px;font-family: sans-serif">{{record.value1}}</td>
                <td style="font-size: 12px;font-family: sans-serif">{{record.date1}}</td>
                <td style="font-size: 12px;font-family: sans-serif">{{record.date2}}</td>
                <td style="font-size: 12px;font-family: sans-serif"></td>

              </tr>
            </tbody>

          </table>

        </div>
      </div>


      <div class="column3">
        <p style="font-size: 14px;font-family: sans-serif">Product Catalogue</p>
        <select id="plans" [(ngModel)]="selectedPlan" style="border-radius:4px;margin-left:5px;">
          <option value="" style="font-size: 12px;font-family: sans-serif">All</option>
          <option *ngFor="let plan of plans" [value]="plan" style="font-size: 12px;font-family: sans-serif" >{{ plan }}</option>
        </select>
      </div>
      <div class="column4">
        <p style="font-size: 14px;font-family: sans-serif">Actions</p>
        <!-- Dropdown for selecting an action -->
        <select id="plans" [(ngModel)]="selectedAction" (change)="onActionSelect()" style="border-radius: 4px;">
          <option value="" style="font-size: 12px;">Select an Action</option>
          <option *ngFor="let action of actions" [value]="action" style="font-size: 12px;font-family: sans-serif">{{ action }}</option>
        </select>
      </div>


      <div class="column5">
        <p style="font-size: 14px;font-family: sans-serif;position:relative;">Search</p>
      
        <input type="text" id="iconified" placeholder="" style="width:130px;height:23px;border-radius:4px;position: absolute
        ;">
        <i class="fa fa-search" aria-hidden="true"></i>

        
      </div>
      </div>
    
    <!-- Conditionally display the table based on selected action -->
     <!-- Create Catalog Form -->
<div *ngIf="selectedAction === 'Create New Tax Table'" class="catalog-form">
  <h3 style="font-size: 14px;font-family: sans-serif;height:25px;">Create New Tax Table</h3>
  <form (ngSubmit)="submitNewCatalog()">
    <div>
      <label for="name" style="font-size: 12px;font-family: sans-serif;margin-right:15px;margin-bottom:10px;">Tax Id</label>
      <input type="text" id="name" [(ngModel)]="newCatalog.name" name="name" required />
    </div>

    <div>
      <label for="description" style="font-size: 12px;font-family: sans-serif;margin-right:88px;margin-bottom:10px;">Tax</label>
      <input type="text" id="description" [(ngModel)]="newCatalog.description" name="description" required>
     
    </div>

    <div>
      <label for="version" style="font-size: 12px;font-family: sans-serif;margin-right:67px;margin-bottom:10px;">Version</label>
      <input type="text" id="version" [(ngModel)]="newCatalog.version" name="version" required />
    </div>

    <div>
      <label for="startDate" style="font-size: 12px;font-family: sans-serif;margin-bottom:10px;margin-right:54px;">Start Date</label>
      <input type="date" id="startDate" [(ngModel)]="newCatalog.startDate" name="startDate" required />
    </div>

    <div>
      <label for="endDate" style="font-size: 12px;font-family: sans-serif;margin-right:57px;">End Date</label>
      <input type="date" id="endDate" [(ngModel)]="newCatalog.endDate" name="endDate" required />
    </div>

    <button type="submit" style="font-size: 12px;font-family: sans-serif">Create Catalog</button>
  </form>
</div>
<div *ngIf="catalogs.length > 0">
  <h4 style="font-size: 14px;font-family: sans-serif">Created Catalogues</h4>
  <table class="table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Tax</th>
        <th>Version</th>
        <th>Start Date</th>
        <th>End Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let catalog of catalogs">
        <td style="font-size: 12px;
        font-family: sans-serif;
        margin-right: 25px;
        margin-bottom: 20px;
        margin-top: 20px;">{{ catalog.name }}</td>
       
        <td style="font-size: 12px;
        font-family: sans-serif;
        margin-right: 96px;
        margin-bottom: 20px;
        margin-top: 20px;">{{ catalog.tax }}</td>
        <td  style="font-size: 12px;
        font-family: sans-serif;
        margin-right: 96px;
        margin-bottom: 20px;
        margin-top: 20px;"style="margin-right:20px;margin-bottom:20px;">{{ catalog.version }}</td>
        <td>{{ catalog.startDate }}</td>
        <td>{{ catalog.endDate }}</td>
      </tr>
    </tbody>
  </table>
</div>


<div class="table-responsive mt-2" *ngIf="selectedAction != ''">
  <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_0"
    class="table text-nowrap w-100">
    
    <thead>
      
        
        <tr>
          <!-- <th>Version</th> -->
          <th>Tax Category</th>
          <th>Description</th>
          <th *ngFor="let province of provinceKeys">{{province}}</th>
          <th>Actions</th>

        </tr>

       
    </thead>
      <tbody>
      <tr *ngFor="let rowss of allProvinces1; let i = index">
        <td>{{taxData1[i].taxCategory}}</td>
        <td>{{taxData1[i].description}}</td>
        <td *ngFor="let provinceData of rowss">
          {{ provinceData.taxRate }}
        </td>
        <td>
          <div style="
            display: flex;
            align-items: center;
            justify-content: center;
        ">
          <i  class="fa fa-trash-o pe-1" style="color:red; font-size:15px"></i><i class="fa fa-pencil" aria-hidden="true"></i>
        </div>
        </td>
      </tr>
      
    </tbody>

    <ng-template #loadingState>
      <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="loader">
        <td *ngFor="let j of [1, 2, 3, 4, 5, 6, 7]">
          <div class="is-loading">
            <p></p>
          </div>
        </td>
      </tr>
    </ng-template>
  </table>
</div>




   

  </div>
  



</main>